import { AuthenticationService } from './authentication.service';
import { AuthenticationDelgate } from './authentication.delegate';
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService';
import { StorageService } from '../storage';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class AuthenticationServiceFactory {
    static create(config: IAppConfig, spinnerService?: SpinnerService): AuthenticationService {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const authDelegate = new AuthenticationDelgate(httpProvider);
        const storageService = new StorageService();
        
        return new AuthenticationService(authDelegate, storageService);
    }
}